import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

import { Sidebar, Topbar } from './components';
import { useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';

// TODO jss-to-tss-react codemod: Unable to handle style definition reliably. Unsupported arrow function syntax.
//Unexpected value type of MemberExpression.
const useStyles = makeStyles()((theme) => ({
  root: {
    // paddingTop: 56,
    // height: '100%',
    // [theme.breakpoints.up('sm')]: {
    //   paddingTop: 64,
    // },
    // [theme.breakpoints.up('xs')]: {
    //   paddingTop: 56,
    // },
    display: 'flex',
  },
  shiftContent: {
    paddingLeft: 240,
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
}));

const Main = (props) => {
  const { classes, cx } = useStyles();
  const theme = useTheme();
  const [openSidebar, setOpenSidebar] = useState(false);
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('lg'), {
    defaultMatches: false,
  });

  useEffect(() => {
    setOpenSidebar(!isSmallDevice);
  }, [isSmallDevice]);

  const handleToggleMenu = () => {
    setOpenSidebar((o) => !o);
  };

  return (
    <div
      className={cx({
        [classes.root]: true,
        // [classes.shiftContent]: isDesktop,
      })}
    >
      <Topbar open={openSidebar} onToggleMenu={handleToggleMenu} />
      <Sidebar
        open={openSidebar}
        // variant={isDesktop ? 'persistent' : 'temporary'}
      />
      <main id="infiniteScrollDiv" className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Outlet />
        {/* <Footer /> */}
      </main>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node,
};

export default Main;
